export default "__VITE_ASSET__2f279c00__"